<template>
    <div class="cu-questions-scree mt-2">
        <b-modal id="showFindAndReplaceModalSeries" ref="showFindAndReplaceModalSeries" title="Find & Replace" size="lg"
            @ok="onConfirmReplacementS" @hide="onFindReplaceModalCloseS" ok-title="Save" :ok-disabled="isSaveDisabledS">
            <form @submit.prevent="onFindS">
                <b-form-group label="Find Text" label-for="find-input">
                    <b-form-input id="find-input" v-model="findTextS" placeholder="Enter text to find"></b-form-input>
                </b-form-group>

                <b-form-group label="Replace With" label-for="replace-input">
                    <b-form-input id="replace-input" v-model="replaceTextS"
                        placeholder="Enter replacement text"></b-form-input>
                </b-form-group>

                <div class="d-flex flex-row">
                    <div class="w-50" style="overflow-wrap: break-word; white-space: pre-wrap;">
                        <h5>Match Results</h5>
                        <div v-if="foundTextsS.length > 0">
                            <p class="mb-0" v-for="(item, index) in foundTextsS" :key="index"
                                v-html="item[selectedColumnS]"></p>
                        </div>
                        <p v-else>No match found</p>
                    </div>
                    <div v-if="modifiedTextsS.length > 0" class="w-50"
                        style="overflow-wrap: break-word; white-space: pre-wrap;">
                        <h5>Text after Replacement</h5>
                        <div>
                            <p class="mb-0" v-for="(item, index) in modifiedTextsS" :key="index"
                                v-html="item[selectedColumnS]"></p>
                        </div>
                    </div>
                </div>

                <!-- Buttons -->
                <div class="d-flex justify-start mt-2">
                    <b-button variant="primary mr-2" @click="onFindS" :disabled="!findTextS">Find</b-button>
                    <b-button variant="danger" @click="onReplaceS"
                        :disabled="!foundTextsS.length > 0 || !replaceTextS || !findTextS">Replace</b-button>
                </div>

            </form>
        </b-modal>

        <div class="row" style=" position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;">
            <div class="col-6 d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <div class="qu-icon-radius d-flex align-items-center">
                        <feather-icon icon="PlusIcon" size="17" class="qu-icon-grey" />
                    </div>
                    <p class="fs-105 fs-options-1 qu-fw-400 mb-0 ml-1" style="margin-top: 4px">
                        Series
                    </p>

                    <SeriesPreviewQuestions :questions="questions" />
                    <MoveQuestionsModalSeries :questionsToMoveSeries="selectedQuestionsToMoveSeries"
                        @getUpdatedQuestionsDataSeries="getUpdatedDataSeries"
                        @ResetQuestionsSeries="ResetQuestionsCheckBoxSeries" />
                    <!-- question feedback modal -->
                    <QuestionFeedbackModal v-if="isQuestionFeedbackModalOpen" :question="selectedQuestionForFeedback"
                        :isModalOpen="isQuestionFeedbackModalOpen" @close="closeFeedbackModal"
                        @saveFeedbackResponse="handleFeedbackResponse" />

                    <QuestionLogModalSeries :selectedQuestion="selectedQuestionForLogSeries._id" />
                </div>
            </div>
            <div class="col-6">
                <div class="
                        d-flex
                        flex-row
                        gap-25
                        align-items-center
                        justify-content-end
                    ">
                    <template>
                        <div>
                            <b-dropdown text="Action" variant="primary" :disabled="isDisableActionSeries">
                                <b-dropdown-item @click="moveQuestionsSeries">Move Questions</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </template>
                    <span v-click-outside="hideFields" id="hide-show-fields">
                        <div class="qu-fc-color text-nowrap" @click="hideShowField" id="hide-show-btn">
                            Show/Hide Fields
                            <feather-icon icon="ChevronDownIcon" />
                        </div>
                        <div v-if="isFieldDropdown" class="position-absolute p-1" style="
                                width: 200px;
                                height: 110px;
                                background-color: #fff;
                                border-radius: 10px;
                                margin-top: 5px;
                            ">
                            <div class="d-flex">
                                <b-form-checkbox v-model="isTitle">
                                </b-form-checkbox>
                                Title
                            </div>
                            <div class="d-flex mt-1">
                                <b-form-checkbox v-model="isDescription">
                                </b-form-checkbox>
                                Description
                            </div>
                            <div class="d-flex mt-1">
                                <b-form-checkbox v-model="isPattern">
                                </b-form-checkbox>
                                Patterns
                            </div>
                        </div>
                    </span>
                    <ExportSeriesQuestionForGpt :questions="questions" />
                    <AddSeriesQuestionGptResponse :error="errorMsg" @createQuestionJson="createQuestionJson"
                        @resetGptModel="resetGptModel"
                        v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content" />
                    <div v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content"
                        class="
                            d-flex
                            align-items-center
                            border-grey
                            qu-fc-color
                            curser-pointer
                        " @click="confirmDelete">
                        <feather-icon icon="TrashIcon" />
                        <span class="text-nowrap qu-margin-left-10">Delete</span>
                    </div>
                    <div>
                        <b-input-group>
                            <b-button variant="primary" @click="addNewQuestion"
                                v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content">
                                New
                            </b-button>
                        </b-input-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2 overflow-auto" style="padding-bottom:5px; max-height: 500px;
  overflow-y: auto;
  position: relative;">
            <div class="table-container custom-table-questions">
                <div class="table-header" style="border-top: 1px solid #ebe9f1">
                    <div v-if="!isStickyNumber" class="header-cell cu-padding" style="width: 130px"></div>
                    <div v-if="!isStickyNumber" class="
                            header-cell
                            text-center
                            cu-padding
                            position-relative
                        " style="width: 150px">
                        <img src="/setting1.png" alt="" class="table-heading-margin img-width" />
                        <span>Setting</span>
                        <span class="position-absolute" style="right: 5px">
                            <feather-icon class="curser-pointer" @click="updateStickFunction" style="color: #7367f0"
                                icon="BookmarkIcon" />
                        </span>
                    </div>
                    <div v-if="isStickyNumber || isStickyTitle" :class="{
                        'sticky-column': isStickyNumber || isStickyTitle,
                    }">
                        <div v-if="isStickyNumber" class="header-cell cu-padding" style="width: 120px"
                            :class="{ 'sticky-column': isStickyNumber }"></div>
                        <div v-if="isStickyNumber" class="
                                header-cell
                                text-center
                                cu-padding
                                position-relative
                            " style="width: 150px">
                            <img src="/setting1.png" alt="" class="table-heading-margin img-width" />
                            <span>Setting</span>
                            <span class="position-absolute" style="right: 5px">
                                <feather-icon class="curser-pointer" @click="updateStickFunction" style="color: #7367f0"
                                    icon="BookmarkIcon" fill="#7367f0" />
                            </span>
                        </div>
                        <div class="
                                header-cell
                                text-center
                                cu-padding
                                position-relative
                            " style="width: 450px" v-if="isStickyTitle && isTitle">
                            <img src="/title.png" alt="" class="table-heading-margin img-width" />
                            <span>Title</span>
                            <span class="position-absolute" style="right: 5px">
                                <feather-icon class="curser-pointer" @click="updateStickTitle" style="color: #7367f0"
                                    icon="BookmarkIcon" fill="#7367f0" />
                            </span>
                        </div>
                    </div>
                    <div class="
                            header-cell
                            text-center
                            cu-padding
                            position-relative
                        " style="width: 450px" v-if="!isStickyTitle && isTitle">
                        <img src="/title.png" alt="" class="table-heading-margin img-width" />
                        <span>Title</span>
                        <span class="position-absolute" style="right: 5px">
                            <feather-icon class="curser-pointer" @click="updateStickTitle" style="color: #7367f0"
                                icon="BookmarkIcon" />
                        </span>
                    </div>
                    <div class="
                            header-cell
                            text-center
                            position-relative
                            cu-padding
                        " :class="{ 'sticky-column': isStickyDescription }" v-if="isDescription"
                        v-for="(n, index) in descriptionCount" :key="index + 'descth'" :style="{ width: '450px' }">
                        <img v-if="index == 0" src="/desc.png" alt="" class="table-heading-margin img-width" />
                        <span v-if="index == 0">Descriptions</span>
                        <span class="position-absolute" style="right: 5px">
                            <feather-icon v-if="index >= 0" class="curser-pointer" @click="addDescription"
                                style="color: #7367f0" icon="PlusIcon" />
                            <feather-icon v-if="index > 0" class="curser-pointer" @click="removeDescription(index)"
                                style="color: red" icon="TrashIcon" />
                        </span>
                    </div>
                    <div class="
                            header-cell
                            text-center
                            position-relative
                            cu-padding
                        " style="width: 225px">
                        <img src="/hint.png" alt="" class="table-heading-margin img-width" />
                        <span>Correct Option Hint</span>
                    </div>
                    <div class="d-flex flex-direction-row" v-if="isPattern" v-for="(n, index) in patternCount"
                        :key="index + 'pattern'">
                        <div class="
                                header-cell
                                text-center
                                cu-padding-series
                                position-relative
                            " :style="{ width: '450px' }">
                            <div>
                                <img src="/desc.png" alt="" class="table-heading-margin img-width" />
                                <span>Pattern {{ n }}</span>
                                <span class="position-absolute" style="right: 5px">
                                    <feather-icon v-if="index >= 0" class="curser-pointer" @click="addPattern"
                                        style="color: #7367f0;" icon="PlusIcon" />
                                    <feather-icon v-if="index > 0" class="curser-pointer" @click="removePattern(index)"
                                        style="color: red" icon="TrashIcon" />
                                </span>
                            </div>
                        </div>
                        <template v-if="questions.length > 0">
                            <div class="
                                header-cell
                                text-center
                                cu-padding-series
                                position-relative
                            " :style="{ width: '450px' }"
                                v-for="(n, groupIndex) in questions[0].patterns[index].optionsGroups.length"
                                :key="index + generateRandomNumber()">
                                <img src="/desc.png" alt="" class="table-heading-margin img-width" />
                                <span>Group {{ n }}</span>
                                <span class="position-absolute" style="right: 5px">
                                    <feather-icon v-if="index >= 0" class="curser-pointer" @click="addGroup(index)"
                                        style="color: #7367f0" icon="PlusIcon" />
                                    <feather-icon v-if="groupIndex > 0" class="curser-pointer"
                                        @click="removeOptionGroup(index, groupIndex)" style="color: red"
                                        icon="TrashIcon" />
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="
                                header-cell
                                text-center
                                cu-padding-series
                                position-relative
                            " :style="{ width: '450px' }">
                                <img src="/desc.png" alt="" class="table-heading-margin img-width" />
                                <span>Group</span>
                                <span class="position-absolute" style="right: 5px">
                                    <feather-icon class="curser-pointer" @click="addGroup(index)" style="color: #7367f0"
                                        icon="PlusIcon" />
                                    <feather-icon v-if="index > 0" class="curser-pointer"
                                        @click="removeOptionGroup(indexs, 0)" style="color: red" icon="TrashIcon" />
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="table-body">
                    <div class="d-flex" style="border-top: 1px solid #ebe9f1">
                        <div v-if="!isStickyNumber" class="cell fs-0625" style="width: 70px">
                            <b-form-checkbox class="m-auto" style="width: fit-content"
                                v-on:change="checkUncheckQuestion()" v-model="tableCheckbox"></b-form-checkbox>
                        </div>
                        <div v-if="!isStickyNumber" class="cell fs-0625" style="width: 60px">
                            <p class="m-auto mb-0" style="width: fit-content">
                                #
                            </p>
                        </div>
                        <div v-if="!isStickyNumber" class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                            style="width: 150px">
                            Plugin
                        </div>
                        <div v-if="isStickyNumber || isStickyTitle" class="d-flex flex-row" :class="{
                            'sticky-column':
                                isStickyNumber || isStickyTitle,
                        }">
                            <div v-if="isStickyNumber" class="cell fs-0625" style="width: 60px">
                                <b-form-checkbox class="m-auto" style="width: fit-content"
                                    v-on:change="checkUncheckQuestion()" v-model="tableCheckbox"></b-form-checkbox>
                            </div>
                            <div v-if="isStickyNumber" class="cell fs-0625" style="width: 60px">
                                <p class="m-auto mb-0" style="width: fit-content">
                                    #
                                </p>
                            </div>
                            <div v-if="isStickyNumber"
                                class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                style="width: 150px">
                                Plugin
                            </div>
                            <div v-if="isStickyTitle" class="d-flex flex-row">
                                <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight "
                                    v-if="isTitle" style="width: 225px">
                                    Question title

                                </div>
                                <div class="cell position-relative fs-0625 justify-content-center cu-txt-color-font-weight"
                                    style="width: 225px" v-if="isTitle">
                                    TTS

                                    <span class="position-absolute" style="right: 5px">
                                        <feather-icon class="curser-pointer" @click="copyQuestionTts"
                                            style="color: #47464a" icon="CopyIcon" />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="!isStickyTitle" class="d-flex flex-row" :class="{ 'sticky-column': isStickyTitle }">
                            <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight position-relative"
                                v-if="isTitle" style="width: 225px">
                                Question title
                                <span v-if="questions.length > 0" class="position-absolute" style="right: 10px"
                                    v-b-modal.showFindAndReplaceModalSeries @click="setColumnNameS('title')">
                                    <feather-icon class="curser-pointer" style="color:  #47464a" icon="SearchIcon" />
                                </span>
                            </div>
                            <div class="cell position-relative fs-0625 justify-content-center cu-txt-color-font-weight"
                                style="width: 225px" v-if="isTitle">
                                TTS
                                <span v-if="questions.length > 0" class="position-absolute" style="right: 25px"
                                    v-b-modal.showFindAndReplaceModalSeries @click="setColumnNameS('titleTts')">
                                    <feather-icon class="curser-pointer" style="color:  #47464a" icon="SearchIcon" />
                                </span>
                                <span class="position-absolute" style="right: 5px">
                                    <feather-icon class="curser-pointer" @click="copyQuestionTts" style="color: #47464a"
                                        icon="CopyIcon" />
                                </span>
                            </div>
                        </div>
                        <div v-for="(i, index) in descriptionCount" v-if="isDescription" class="d-flex flex-row"
                            :class="{ 'sticky-column': isStickyDescription }">
                            <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                style="width: 225px">
                                Description text {{ i }}
                            </div>
                            <div class="cell position-relative justify-content-center cu-txt-color-font-weight"
                                style="font-size: 10px; width: 225px">
                                Description TTS {{ i }}
                                <span class="position-absolute" style="right: 5px">
                                    <feather-icon class="curser-pointer" @click="copyDescitpionTts(index)"
                                        style="color: #47464a" icon="CopyIcon" />
                                </span>
                            </div>
                        </div>

                        <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight" style="width: 225px">
                            <!-- <img src="/hint.png" alt="" class="table-heading-margin img-width" /> -->
                            <span>Hint</span>
                        </div>
                        <div v-for="(i, index) in patternCount" v-if="isPattern" class="d-flex flex-row">
                            <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                style="width: 225px">
                                Expression {{ i }}
                            </div>
                            <div class="cell position-relative justify-content-center cu-txt-color-font-weight"
                                style="font-size: 10px; width: 225px">
                                Answer {{ i }}
                            </div>
                            <template v-if="questions.length > 0">
                                <div :style="{ width: '450px' }" class="d-flex"
                                    v-for="(n, index) in questions[0].patterns[index].optionsGroups.length"
                                    :key="index + generateRandomNumber()">
                                    <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                        style="width: 225px">
                                        Group text {{ n }}
                                    </div>
                                    <div class="cell position-relative fs-0625 justify-content-center cu-txt-color-font-weight"
                                        style="width: 225px">
                                        Group text TTS {{ n }}
                                        <span class="position-absolute" style="right: 5px">
                                            <feather-icon class="curser-pointer" @click="copyOptionGroupTts(index)"
                                                style="color: #47464a" icon="CopyIcon" />
                                        </span>
                                    </div>
                                    <!-- <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                        style="width: 70px">
                                        Correct {{ n }}
                                    </div> -->
                                </div>
                            </template>
                            <template v-else>
                                <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight d-flex"
                                    style="width: 225px">
                                    Group text 1
                                </div>
                                <div class="cell position-relative fs-0625 justify-content-center cu-txt-color-font-weight"
                                    style="width: 225px">
                                    Group text TTS 1
                                    <span class="position-absolute" style="right: 5px">
                                        <feather-icon class="curser-pointer" @click="copyOptionTts(index)"
                                            style="color: #47464a" icon="CopyIcon" />
                                    </span>
                                </div>
                                <!-- <div class="cell fs-0625 justify-content-center cu-txt-color-font-weight"
                                    style="width: 70px">
                                    Correct 1
                                </div> -->
                            </template>
                        </div>
                    </div>
                    <draggable v-model="questions" group="people" @start="onDragStart" @end="onDragEnd"
                        handle=".handle">
                        <div v-for="(question, questionIndex) in questions" :key="questionIndex + 'question'"
                            class="d-flex input-cells hover-question-row" style="border-top: 1px solid #ebe9f1"
                            :class="{ 'qu-fc-color-red': questionColorChange && questionColorChange == question._id ? true : false }">
                            <div v-if="!isStickyNumber" class="cell position-relative" :style="{
                                width: '70px',
                                // backgroundColor: hasFeedback(question._id) ? '#ff4d4d' : 'unset'
                                backgroundColor: getBackgroundColor(question._id),
                            }">

                                <div style=" position: absolute; top:-10; left:0; display: flex;
                                flex-direction: column;
                                justify-content: center; align-items: center;"
                                    :class="{ 'top-negative-60-for-last-index-series': questionIndex == questions.length - 1 ? true : false }">

                                    <feather-icon icon="CopyIcon" @click="duplicateQuestion(question)"
                                        style=" color: black; margin-bottom: 3px; cursor: pointer" size="16"
                                        class="move-duplicate-hover" />
                                    <feather-icon icon="MoveIcon"
                                        style="color: black; margin-bottom: 3px; cursor: pointer" size="16"
                                        class="handle move-duplicate-hover" />
                                    <img src="/feedback.png" @click="addFeedback(question)" style="cursor: pointer; margin-bottom: 2px;
                            " alt="Feedback" class="move-duplicate-hover feedback-icon" width="15" height="15" />
                                    <img src="/history.svg" @click="ViewQuestionLogSeries(question)"
                                        v-b-modal.question-log-modal-series
                                        style="cursor: pointer; z-index: 999999999 !important; margin-bottom: 2px;"
                                        alt="view log" class="move-duplicate-hover feedback-icon" width="17"
                                        height="17" />
                                </div>
                                <!-- <feather-icon icon="MoveIcon" style="
                                        position: absolute;
                                        top: 2px;
                                        left: 2px;
                                        color: black;
                                    " size="16" class="handle move-duplicate-hover" />
                                <feather-icon icon="CopyIcon" @click="duplicateQuestion(question)" style="
                                        position: absolute;
                                        bottom: 0px;
                                        left: 2px;
                                        color: black;
                                    " size="16" class="move-duplicate-hover" /> -->
                                <b-form-checkbox v-model="question.checkbox" @change="toggleSelectedQuestion()"
                                    class="m-auto"
                                    style="width: fit-content; padding-left:  1.5rem !important;"></b-form-checkbox>

                                <!-- //for feedback -->

                                <!-- <feather-icon icon="MessageSquareIcon" @click="addFeedback(question)" style="
                                        position: absolute;
                                        top: 2px;
                                        right: 2px;
                                    " size="16" class="move-duplicate-hover feedback-icon" /> -->
                                <!-- <img src="/feedback.png" @click="addFeedback(question)" style="
                                position: absolute;
                                top: 2px;
                                right: 2px;
                                cursor: pointer;
                            " alt="Feedback" class="move-duplicate-hover feedback-icon" width="15" height="15" /> -->
                            </div>
                            <div v-if="!isStickyNumber" class="cell" style="width: 60px">
                                <div class="cu-tooltip">
                                    {{ question.questionNo }}
                                </div>
                            </div>
                            <div v-if="!isStickyNumber" class="cell" style="width: 150px">
                                <b-form-select v-model="question.plugin" :options="plugins"></b-form-select>
                            </div>
                            <div v-if="isStickyNumber || isStickyTitle" class="d-flex flex-row" :class="{
                                'sticky-column':
                                    isStickyNumber || isStickyTitle,
                            }">
                                <div v-if="isStickyNumber" class="cell position-relative" style="width: 60px">
                                    <feather-icon icon="MoveIcon" style="
                                            position: absolute;
                                            top: 2px;
                                            left: 2px;
                                        " size="12" class="handle move-duplicate-hover" />
                                    <feather-icon icon="CopyIcon" @click="duplicateQuestion(question)" style="
                                            position: absolute;
                                            bottom: 5px;
                                            left: 2px;
                                        " size="14" class="move-duplicate-hover" />
                                    <b-form-checkbox v-model="question.checkbox" @change="toggleSelectedQuestion()"
                                        class="m-auto" style="width: fit-content"></b-form-checkbox>
                                </div>
                                <div v-if="isStickyNumber" class="cell" style="width: 60px">
                                    <div class="cu-tooltip">
                                        {{ question.questionNo }}
                                    </div>
                                </div>
                                <div v-if="isStickyNumber" class="cell" style="width: 150px">
                                    <b-form-select v-model="question.plugin" :options="plugins"></b-form-select>
                                </div>
                                <div v-if="isStickyTitle" class="d-flex flex-row">
                                    <div contenteditable="false" class="cell p-0 position-relative" v-if="isTitle"
                                        style="width: 225px">
                                        <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                            v-html="question.title" @focus="onFocus"
                                            @blur="onBlur($event, questionIndex, 'title')">
                                        </div>
                                    </div>
                                    <div class="cell p-0 position-relative" v-if="isTitle" style="width: 225px">
                                        <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                            v-html="question.titleTts" @focus="onFocus"
                                            @blur="onBlur($event, questionIndex, 'titleTts')">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!isStickyTitle" class="d-flex flex-row">
                                <div class="cell p-0 position-relative" v-if="isTitle" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="question.title" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'title')">
                                    </div>
                                </div>
                                <div class="cell p-0 position-relative" v-if="isTitle" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="question.titleTts" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'titleTts')">
                                    </div>
                                </div>
                            </div>
                            <div v-for="(
desc, descIndex
                                ) in question.descriptions" v-if="isDescription" class="d-flex flex-row" :class="{
                                    'sticky-column': isStickyDescription,
                                }">
                                <div class="cell p-0 position-relative" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="desc.title" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'desc', descIndex, 'title')">
                                    </div>
                                    <template
                                        v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content">
                                        <b-dropdown v-if="desc.image == null || desc.image.length == 0"
                                            class="position-absolute" style="right:-17px" variant="link" no-caret>
                                            <template #button-content>
                                                <feather-icon icon="UploadIcon" size="20"
                                                    class="qu-icon-grey curser-pointer"
                                                    @click="showFullScreenModal('', questionIndex, descIndex, 'desc')" />
                                            </template>
                                            <b-dropdown-item
                                                @click="triggerFileInput(imgUploadQuestion, imgUploadoptionIndex, uploadType)">
                                                <feather-icon icon="UploadIcon" />
                                                <span class="align-middle ml-50">Upload</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="showGalleryImages">
                                                <feather-icon icon="ImageIcon" />
                                                <span class="align-middle ml-50">Gallery Images</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                    <input :ref="'ref_Input_desc' + descIndex" type="file"
                                        accept="image/x-png,image/gif,image/jpeg,application/json,.json,image/svg+xml,.svg,.lottie"
                                        class="d-none" @change="ImageRendererItems" />
                                    <div v-for="(
img
                                ) in desc.image" class="position-absolute" style="right: 5px;">

                                        <div v-if="getFileExtensionFromUrl(img.url) == 'json'"
                                            @click="showFullScreenModal(img.url, questionIndex, descIndex, 'desc')"
                                            :style="{ cursor: 'pointer', }">
                                            <LottieView :url="img.url"
                                                @click="showFullScreenModal(img.url, questionIndex, descIndex, 'desc')"
                                                :key="keyForLottie" />
                                        </div>
                                        <div v-else-if="getFileExtensionFromUrl(img.url) === 'lottie'"
                                            @click="showFullScreenModal(img.url, questionIndex, descIndex, 'desc')"
                                            :style="{ cursor: 'pointer', }">
                                            <DoLottieView :url="img.url" :id="`description_${question._id}_${uuidv4()}`"
                                                :key="keyForLottie" />
                                        </div>

                                        <div v-else
                                            @click="showFullScreenModal(img.url, questionIndex, descIndex, 'desc')"
                                            :style="{ cursor: 'pointer', }">
                                            <img @click="showFullScreenModal(img.url, questionIndex, descIndex, 'desc')"
                                                :src="img.url" height="30" :alt="img.name" />
                                        </div>

                                    </div>
                                </div>
                                <div class="cell p-0 position-relative" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="desc.tts" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'desc', descIndex, 'tts')">
                                    </div>
                                </div>
                            </div>


                            <div class="d-flex flex-row">
                                <div class="cell p-0 position-relative" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="question.hint.text" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'hint')">
                                    </div>
                                    <template
                                        v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content">
                                        <b-dropdown
                                            v-if="question.hint.image == null || question.hint.image.length == 0 || question.hint.image[0].image == null"
                                            class="position-absolute" style="right:-17px" variant="link" no-caret>
                                            <template #button-content>
                                                <feather-icon icon="UploadIcon" size="20"
                                                    class="qu-icon-grey curser-pointer"
                                                    @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')" />
                                            </template>
                                            <b-dropdown-item
                                                @click="triggerFileInput(imgUploadQuestion, '', uploadType)">
                                                <feather-icon icon="UploadIcon" />
                                                <span class="align-middle ml-50">Upload</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="showGalleryImages">
                                                <feather-icon icon="ImageIcon" />
                                                <span class="align-middle ml-50">Gallery Images</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>

                                    <input :ref="'ref_Input_hint'" type="file"
                                        accept="image/x-png,image/gif,image/jpeg,application/json,.json,image/svg+xml,.svg,.lottie"
                                        class="d-none" @change="ImageRendererItems" />

                                    <div class="position-absolute" style="right: 40px;">
                                        <div v-if="getFileExtensionFromUrl(question.hint.image) == 'json'"
                                            @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')"
                                            :style="{ cursor: 'pointer', }">
                                            <LottieView :url="question.hint.image"
                                                @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')"
                                                :key="keyForLottie" />
                                        </div>
                                        <div v-else-if="getFileExtensionFromUrl(question.hint.image) === 'lottie'"
                                            @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')"
                                            :style="{ cursor: 'pointer', }">
                                            <DoLottieView :url="question.hint.image"
                                                :id="`hint_${question._id}_${uuidv4()}`" :key="keyForLottie" />
                                        </div>

                                        <div v-else
                                            @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')"
                                            :style="{ cursor: 'pointer', }">
                                            <img @click="showFullScreenModal(question.hint.image, questionIndex, '', 'hint', '')"
                                                :src="question.hint.image" height="30" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-for="(
pattern, patternIndex
                                ) in question.patterns" v-if="isPattern" class="d-flex flex-row">
                                <div class="cell p-0 position-relative" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="pattern.expression" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'expression', patternIndex, 'expression')">
                                    </div>
                                    <template
                                        v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content">
                                        <b-dropdown v-if="pattern.image == null || pattern.image.length == 0"
                                            class="position-absolute" style="right:-17px" variant="link" no-caret>
                                            <template #button-content>
                                                <feather-icon icon="UploadIcon" size="20"
                                                    class="qu-icon-grey curser-pointer"
                                                    @click="showFullScreenModal('', questionIndex, patternIndex, 'pattern')" />
                                            </template>
                                            <b-dropdown-item
                                                @click="triggerFileInput(imgUploadQuestion, imgUploadoptionIndex, uploadType)">
                                                <feather-icon icon="UploadIcon" />
                                                <span class="align-middle ml-50">Upload</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="showGalleryImages">
                                                <feather-icon icon="ImageIcon" />
                                                <span class="align-middle ml-50">Gallery Images</span>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                    <input :ref="'ref_Input' + patternIndex" type="file"
                                        accept="image/x-png,image/gif,image/jpeg,application/json,.json,image/svg+xml,.svg,.lottie"
                                        class="d-none" @change="ImageRendererItems" />
                                    <div v-for="(
img
                                ) in pattern.image" class="position-absolute" style="right: 5px;">
                                        <img @click="showFullScreenModal(img.url, questionIndex, patternIndex, 'pattern')"
                                            :src="img.url" height="30" :alt="img.name" />
                                    </div>
                                </div>
                                <div class="cell p-0 position-relative" style="width: 225px">
                                    <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                        v-html="pattern.answer" @focus="onFocus"
                                        @blur="onBlur($event, questionIndex, 'expression', patternIndex, 'answer')">
                                    </div>
                                </div>
                                <template v-for="(optGroup, optGroupIndex) in pattern.optionsGroups">
                                    <div class="cell p-0 position-relative" style="width: 225px">
                                        <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                            v-html="optGroup.title" @focus="onFocus"
                                            @blur="onBlur($event, questionIndex, 'expression', patternIndex, 'title', optGroupIndex)">
                                        </div>
                                        <input :ref="'ref_Input_opt' + optGroupIndex" type="file"
                                            accept="image/x-png,image/gif,image/jpeg,application/json,.json,image/svg+xml,.svg,.lottie"
                                            class="d-none" @change="ImageRendererItems" />
                                        <b-dropdown v-if="optGroup.image == null || optGroup.image == ''"
                                            class="position-absolute" style="right:-17px" variant="link" no-caret>
                                            <template #button-content>
                                                <feather-icon icon="UploadIcon" size="20"
                                                    class="qu-icon-grey curser-pointer"
                                                    @click="showFullScreenModal('', questionIndex, patternIndex, 'group', optGroupIndex)" />
                                            </template>
                                            <b-dropdown-item
                                                @click="triggerFileInput(imgUploadQuestion, imgUploadoptionIndex, uploadType, optGroupIndex, imgUploadGroupQuestion)">
                                                <feather-icon icon="UploadIcon" />
                                                <span class="align-middle ml-50">Upload</span>
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="showGalleryImages">
                                                <feather-icon icon="ImageIcon" />
                                                <span class="align-middle ml-50">Gallery Images</span>
                                            </b-dropdown-item>
                                        </b-dropdown>

                                        <template v-else>

                                            <div v-if="getFileExtensionFromUrl(optGroup.image) == 'json'"
                                                @click="showFullScreenModal(optGroup.image, questionIndex, patternIndex, 'group', optGroupIndex)"
                                                :style="{ cursor: 'pointer', }">
                                                <LottieView :url="optGroup.image"
                                                    @click="showFullScreenModal(optGroup.image, questionIndex, patternIndex, 'group', optGroupIndex)"
                                                    :key="keyForLottie" class="position-absolute"
                                                    style="right: 5px; top: 5px;" />
                                            </div>

                                            <div v-else-if="getFileExtensionFromUrl(optGroup.image) === 'lottie'"
                                                @click="showFullScreenModal(optGroup.image, questionIndex, patternIndex, 'group', optGroupIndex)"
                                                :style="{ cursor: 'pointer' }">
                                                <DoLottieView :url="optGroup.image"
                                                    :id="`optionGroup_${question._id}_${uuidv4()}`" :key="keyForLottie"
                                                    @click="showFullScreenModal(optGroup.image, questionIndex, patternIndex, 'group', optGroupIndex)"
                                                    style="right: 5px; top: 5px;" class="position-absolute" />
                                            </div>

                                            <template v-else>
                                                <img class="position-absolute" style="right: 5px;"
                                                    @click="showFullScreenModal(optGroup.image, questionIndex, patternIndex, 'group', optGroupIndex)"
                                                    :src="optGroup.image" height="30" :alt="optGroup.name" />
                                            </template>

                                        </template>
                                    </div>
                                    <div class="cell p-0 position-relative" style="width: 225px">
                                        <div class="qu-remove-border editable-div single-line" contenteditable="true"
                                            v-html="optGroup.tts" @focus="onFocus"
                                            @blur="onBlur($event, questionIndex, 'expression', patternIndex, 'tts', optGroupIndex)">
                                        </div>
                                    </div>
                                    <!-- <div class="cell" style="width: 70px">
                                        <b-form-checkbox v-model="optGroup.correct" class="m-auto"
                                            style="width: fit-content"></b-form-checkbox>
                                    </div> -->
                                </template>
                            </div>

                        </div>
                    </draggable>
                </div>
            </div>
        </div>
        <div>
            <div class="d-flex" style="border: 1px solid #ebe9f1;margin-top:-5px;">
                <div class="py-1 px-1 w-100 curser-pointer d-flex" style="font-size: 1rem">
                    <div @click="addNewQuestion" class="d-flex"
                        v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content">
                        <feather-icon icon="PlusIcon" size="20" class="qu-icon-grey" />
                        New
                    </div>
                </div>
            </div>
            <SaveSeriesQuestion
                v-if="permissions.permission_manage_topics || permissions.permission_manage_topics_content"
                :updateQuestionsChanges="updateQuestionsChanges" :newQuestion="newQuestion" :questions="questions"
                :keyForLottie="keyForLottie" :originalQuestions="originalQuestions" @saveQuestions="saveQuestions" />
        </div>
        <b-modal v-model="showFullScreen" size="lg">
            <b-button variant="primary"
                @click="triggerFileInput(imgUploadQuestion, imgUploadoptionIndex, uploadType, imgUploadGroupQuestion)">
                Upload
            </b-button>
            <b-button class="ml-1" variant="primary" @click="showGalleryImages">
                Gallery Images
            </b-button>
            <b-button v-if="imageUrl" class="ml-1" variant="danger" @click="removeImage">
                Remove
            </b-button>
            <div class="text-center mt-2">
                <!-- <div v-if="getFileExtensionFromUrl(imageUrl) == 'json'">
                    <LottieView :url="imageUrl" :forModel="true" :key="keyForLottie" />
                </div> -->
                <template v-if="getFileExtensionFromUrl(imageUrl) == 'json'">
                    <LottieView :url="imageUrl" :forModel="true" :key="keyForLottie" />
                </template>
                <template v-else-if="getFileExtensionFromUrl(imageUrl) === 'lottie'">
                    <DoLottieView :url="imageUrl" :forModel="true" :id="`series_model_${uuidv4()}`"
                        :key="keyForLottie" />
                </template>


                <div v-else>
                    <img v-if="imageUrl" :src="imageUrl" alt="Fullscreen" style="height: auto;
    max-width: 100%;" />
                </div>

                <feather-icon v-else
                    @click="triggerFileInput(imgUploadQuestion, imgUploadoptionIndex, uploadType, imgUploadGroupQuestion)"
                    icon="UploadIcon" size="50" class="qu-icon-grey curser-pointer " />
            </div>
        </b-modal>
        <zape-gallery-model :props_hideShowModel="showImage" @modelClose="modelClose"
            @saveCategoryImage="saveCategoryImage" />
    </div>
</template>

<script>
import {
    BCard,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BFormGroup,
    BSpinner,
    BRow,
    BCol,
    BInputGroup,
    BIcon,
    BFormCheckbox,
    BFormSelect,
    BTooltip,
    BFormTextarea,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ClickOutside from "vue-click-outside";
import draggable from "vuedraggable";
import LottieView from "./LottieView.vue";
import Helpers from "@/Helpers";
import SeriesPreviewQuestions from "./SeriesPreviewQuestions.vue";
import DoLottieView from "./DoLottieView.vue";
import { v4 as uuidv4 } from 'uuid';
import MoveQuestionsModalSeries from "./MoveQuestionsModalSeries.vue";
export default {
    components: {
        draggable,
        SaveSeriesQuestion: () => import("./SaveSeriesQuestion.vue"),
        AddSeriesQuestionGptResponse: () => import("./AddSeriesQuestionGptResponse.vue"),
        ZapeGalleryModel: () => import("../Model/ZapeGalleryModel.vue"),
        ExportSeriesQuestionForGpt: () => import("./ExportSeriesQuestionForGpt.vue"),
        QuestionFeedbackModal: () => import("../SaveQuestionFeedbackModal.vue"),
        QuestionLogModalSeries: () => import("../ViewQuestionLogModalSeries.vue"),
        BButton,
        BFormInput,
        BFormGroup,
        BInputGroup,
        BTable,
        BDropdown,
        BDropdownItem,
        BOverlay,
        BSpinner,
        BCard,
        BRow,
        BCol,
        BIcon,
        ToastificationContent,
        BFormCheckbox,
        BFormSelect,
        BTooltip,
        BFormTextarea,
        LottieView,
        SeriesPreviewQuestions,
        uuidv4,
        DoLottieView,
        MoveQuestionsModalSeries
    },
    directives: {
        ClickOutside,
    },
    props: {
        permissions: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            alertMessageToast: "",
            show: false,
            bearerToken: "",
            questions: [],
            plugins: [],
            selectedQuestionsToMoveSeries: [],
            moveQuestionsmodalKey: null,
            // plugins: [
            //     { 'value': "MissingElements", 'text': "Missing Elements" },
            //     { 'value': "DragAndDrop", 'text': "Drag And Drop" },
            //     { 'value': "EvaluateNumbers", 'text': "Evaluate Numbers" },
            //     { 'value': "MissingNumbers", 'text': "Missing Numbers" },
            //     { 'value': "MissingNumbersEvaluate", 'text': "Missing Numbers Evaluate" },
            //     { 'value': "MatchPatterns", 'text': "Match Patterns" },
            //     { 'value': "SentencesCompletionClick", 'text': "Sentences Completion Click" },
            //     { 'value': "WordsCompletion", 'text': "Words Completion" },
            //     { 'value': "NumberChart", 'text': "Number Chart" },
            // ],
            patternCount: 1,
            tableCheckbox: false,
            originalQuestions: [],
            isFieldDropdown: false,
            isTitle: true,
            isPattern: true,
            isOption: true,
            isSelectedQuestion: {},
            isStickyNumber: false,
            isStickyTitle: false,
            isStickyDescription: false,
            drag: false,
            dragIndex: null,
            dropIndex: null,
            errorMsg: "",
            imgUploadQuestion: null,
            imgUploadoptionIndex: null,
            imgUploadGroupQuestion: null,
            imageUrl: null,
            uploadType: null,
            showFullScreen: false,
            showImage: false,
            isDescription: true,
            descriptionCount: 1,
            keyForLottie: 0,
            Helpers,
            findTextS: "",
            replaceTextS: "",
            matchCountS: 0,
            foundTextsS: [],
            modifiedTextsS: [],
            selectedColumnS: "title",
            selectedQuestionForFeedback: null,
            isQuestionFeedbackModalOpen: false,
            levelFeedBackData: [],
            selectedQuestionForLogSeries: "",
            isQuestionLogModalOpen: false,
            viewLogModalSeries: false,
        };
    },

    watch: {
        findTextS(newVal) {
            if (!newVal) {
                this.foundTextsS = [];
                this.modifiedTextsS = [];
            }
        },
        replaceTextS(newVal) {
            if (!newVal) {
                this.modifiedTextsS = [];
            }
        }
    },

    computed: {
        isDisableActionSeries() {
            const selectedQuestions = this.questions.filter(
                (question) => question.checkbox
            ).length;
            return !selectedQuestions;
        },
        isSaveDisabledS() {
            return this.foundTextsS.length === 0 || this.modifiedTextsS.length === 0;
        }
    },

    mounted() {
        window.addEventListener("beforeunload", this.handleBeforeUnload);
        this.bearerToken = "Bearer " + localStorage.getItem("_t");
        this.fetch();
        this.getLevelFeedback();
        this.fetchPlugins();
    },
    beforeDestroy() {
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    },

    created() {
        let id = this.$route.params.questionId;
        this.questionColorChange = id;
    },


    methods: {
        uuidv4,
        ResetQuestionsCheckBoxSeries() {
            this.questions.forEach((question) => {
                question.checkbox = false;
            });
        },
        getUpdatedDataSeries() {
            this.fetch();
            this.getLevelFeedback();

        },
        async moveQuestionsSeries() {
            const selectedQuestions = this.questions.filter(
                (question) => question.checkbox
            )
            this.selectedQuestionsToMoveSeries = selectedQuestions;
            if (this.selectedQuestionsToMoveSeries.length > 0) {

                console.log('selectedQuestions', JSON.stringify(selectedQuestions, null, 10))
                // return;
                if (this.isConsecutiveSequence(selectedQuestions)) {
                    let updatedQuestion = await this.detectChangesInQuestions();
                    let newQuestion = await this.newQuestion();
                    if (updatedQuestion.length == 0 && newQuestion.length == 0) {
                        this.$bvModal.show('MoveQuestionsModalSeries');
                    } else {
                        Swal.fire({
                            title: 'Attention!',
                            text: 'You have unsaved changes! please save first.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                        });
                    }

                } else {
                    Swal.fire({
                        title: 'Attention!',
                        text: 'Please select questions in a sequence',
                        icon: 'error',
                        confirmButtonText: 'OK',
                    });
                }

            } else {
                console.error('No questions selected to move')
            }
        },


        detectChangesInQuestions() {
            const updatedMap = new Map(this.questions.map(obj => [obj._id, obj])); // Convert to Map for faster lookups
            let updateQuestion = [];

            const excludeProperties = (obj, propertiesToIgnore) => {
                const newObj = { ...obj };
                propertiesToIgnore.forEach(prop => delete newObj[prop]);
                return newObj;
            };

            const propertiesToIgnore = ['checkbox'];

            for (let i = 0; i < this.originalQuestions.length; i++) {
                const originalObj = this.originalQuestions[i];
                const updatedObj = updatedMap.get(originalObj._id); // Faster lookup using Map

                if (updatedObj) {
                    const originalCopy = excludeProperties(originalObj, propertiesToIgnore);
                    const updatedCopy = excludeProperties(updatedObj, propertiesToIgnore);

                    if (JSON.stringify(originalCopy) !== JSON.stringify(updatedCopy)) {
                        updateQuestion.push(updatedObj);
                    }
                }
            }

            return updateQuestion;
        },


        isConsecutiveSequence(questions) {
            questions.sort((a, b) => Number(a.questionNo) - Number(b.questionNo));

            // console.log('questionssort', JSON.stringify(questions, null, 2));

            for (let i = 0; i < questions.length - 1; i++) {
                const currentQuestionNo = Number(questions[i].questionNo);
                const nextQuestionNo = Number(questions[i + 1].questionNo);

                // console.log(`Comparing ${currentQuestionNo} + 1 with ${nextQuestionNo}`);

                if (nextQuestionNo !== currentQuestionNo + 1) {
                    return false;
                }
            }
            return true;
        },
        ViewQuestionLogSeries(question) {
            this.viewLogModalSeries = true;
            this.selectedQuestionForLogSeries = question;
        },

        async fetchPlugins() {
            // this.loading = true; 
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}/plugins/questions/get-all`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("_t")}`,
                    },
                });

                if (response.data.success) {
                    // console.log('response.data',response)
                    this.plugins = response.data.data.map(item => ({
                        value: item.plugin,
                        text: item.title,
                    }));

                    // console.log('abc', JSON.stringify(abc, null, 10))

                    // this.plugins = response.data.data;  
                } else {
                    this.error = 'Failed to fetch plugins: ' + response.data.message;
                }
            } catch (error) {
                if (error.response) {

                    if (error.response.status === 401) {
                        this.error = 'Unauthenticated: Please log in.';
                    } else if (error.response.status === 403) {
                        this.error = 'Unauthorized: You do not have permission to view this data.';
                    } else {
                        this.error = 'Error fetching plugins: ' + error.response.data.message;
                    }
                } else {
                    this.error = 'Network error: ' + error.message;
                }
            } finally {
                // this.loading = false;  
            }
        },


        async getLevelFeedback() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_API_URL}/get-level-feedback`, {
                    params: {
                        levelId: this.$route.params.levelId,
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("_t")}`,
                    },
                });

                if (response.data.success) {
                    if (response.data && response.data.feedbacks) {
                        this.levelFeedBackData = response.data.feedbacks;
                    }
                } else {
                    this.alertMessageToast = 'Error in fetching feedback!';
                    this.showToast("danger");
                    console.error('No feedbacks found or error fetching feedback');
                }
            } catch (error) {
                console.error('Error fetching level feedback:', error);
            } finally {
            }
        },


        handleFeedbackResponse(response) {
            if (response && response.status == 'success') {
                this.alertMessageToast = 'Feedback added successfully';
                this.showToast("success");
                this.getLevelFeedback();
            }
            else if (response == 'You do not have permission to give feedback.') {
                this.alertMessageToast = 'You do not have permission to give feedback.';
                this.showToast("danger");
            }
            else {
                this.alertMessageToast = 'Error in adding feedback!';
                this.showToast("danger");

            }
        },

        getBackgroundColor(questionId) {
            const feedbacks = this.levelFeedBackData.filter(feedback => feedback.questionId === questionId);
            // console.log('feedbacks', JSON.stringify(feedbacks, null, 10));

            if (feedbacks.length === 0) {
                return 'unset';
            }
            const hasHidden = feedbacks.some(feedback => feedback.reply[0].hideQuestion === true);

            // console.log('hasHidden', hasHidden) 
            const allNotHidden = feedbacks.every(feedback => feedback.reply[0].hideQuestion === false);
            // console.log('allNotHidden', allNotHidden)
            if (hasHidden) {
                return '#ff4d4d';
            } else if (allNotHidden) {
                return 'orange';
            } else {
                return 'unset';
            }
        },

        addFeedback(question) {
            this.selectedQuestionForFeedback = question;
            this.isQuestionFeedbackModalOpen = true
        },

        closeFeedbackModal() {
            this.isQuestionFeedbackModalOpen = false
        },

        setColumnNameS(columnName) {
            this.selectedColumnS = columnName;
        },

        onFindS() {
            const searchText = this.findTextS ? this.findTextS.toLowerCase() : "";

            if (!searchText) {
                console.log("Error: 'Find Text' is empty.");
                this.foundTextsS = [];
                this.matchCountS = 0;
                return;
            }

            let totalMatchCount = 0;
            this.foundTextsS = this.questions
                .filter((item) => {

                    return item[this.selectedColumnS] && item[this.selectedColumnS].toLowerCase().includes(searchText);
                })
                .map((item) => {
                    const regex = new RegExp(`(${searchText})`, "gi");
                    const highlightedTitle = item[this.selectedColumnS].replace(
                        regex,
                        '<span style="background-color: yellow;">$1</span>'
                    );

                    const matches = item[this.selectedColumnS].match(regex);
                    totalMatchCount += matches ? matches.length : 0;

                    return {
                        _id: item._id,
                        [this.selectedColumnS]: highlightedTitle
                    };
                });

            this.matchCount = totalMatchCount;
        },

        onConfirmReplacementS() {

            if (this.modifiedTextsS.length === 0) {
                console.log('Nothing to replace as modifiedTexts is empty');
                return;
            }

            this.modifiedTextsS.forEach((modifiedItem) => {
                const question = this.questions.find((item) => item._id === modifiedItem._id);

                if (question) {

                    const cleanedTitle = modifiedItem[this.selectedColumnS].replace(/<[^>]*>/g, "");

                    question[this.selectedColumnS] = cleanedTitle;
                }
            });

            this.alertMessageToast = 'Text replaced successfully';
            this.showToast("success");
        },

        onReplaceS() {

            const searchText = this.findTextS ? this.findTextS.toLowerCase() : "";
            const replaceText = this.replaceTextS || "";

            if (!searchText || !replaceText) {
                console.log("Error: Both 'Find Text' and 'Replace Text' must be non-empty.");
                this.modifiedTextsS = [];
                return;
            }

            if (this.foundTextsS.length > 0) {
                this.modifiedTextsS = this.foundTextsS.map((item) => {
                    const regex = new RegExp(`(${searchText})`, "gi");

                    let replacedTitle = item[this.selectedColumnS].replace(
                        regex,
                        replaceText
                    );
                    replacedTitle = replacedTitle.replace(
                        new RegExp(`(${replaceText})`, "gi"),
                        '<span style="background-color: red; color: white;">$1</span>'
                    );

                    return {
                        _id: item._id,
                        [this.selectedColumnS]: replacedTitle
                    };
                });
            }
        },


        onFindReplaceModalCloseS() {
            this.findTextS = '';
            this.replaceTextS = '';
            this.foundTextsS = [];
            this.modifiedTextsS = [];
            this.matchCountS = 0;
        },


        removeDescription(index) {
            const indexToRemove = index;

            this.questions.forEach((question) => {
                if (
                    question.descriptions &&
                    question.descriptions.length > indexToRemove
                ) {
                    question.descriptions.splice(indexToRemove, 1);
                }
            });
            this.descriptionCount = this.descriptionCount - 1;
        },
        getFileExtensionFromUrl(url) {
            if (!url) return '';
            const path = url.split('?')[0].split('#')[0];
            const extension = path.split('.').pop();

            if (extension === path) return '';

            return extension;
        },
        addDescription() {
            this.questions.forEach((question) => {
                question.descriptions.push({
                    title: "",
                    tts: "",
                    type: "text",
                    image: null,
                });
            });
            this.descriptionCount = this.descriptionCount + 1;
        },
        generateRandomNumber() {
            return Math.random();
        },
        copyDescitpionTts(index) {
            this.questions.forEach((question) => {
                question.descriptions[index].tts = question.descriptions[index].title;
            });
        },
        copyOptionTts(index) {

            this.questions.forEach((question) => {
                question.options[index].tts = question.options[index].title;
            });
        },

        copyOptionGroupTts(index) {

            this.questions.forEach((question) => {
                question.patterns[0].optionsGroups[index].tts = question.patterns[0].optionsGroups[index].title;
            });
        },


        copyQuestionTts() {
            this.questions.forEach((question) => {
                question.titleTts = question.title;
            });
        },
        removeImage() {
            let imageObject = [];
            if (this.uploadType == 'pattern') {
                this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].image = imageObject;
            } else if (this.uploadType == 'desc') {
                this.questions[this.imgUploadQuestion].descriptions[this.imgUploadoptionIndex].image = imageObject;
            } else if (this.uploadType == 'hint') {
                this.questions[this.imgUploadQuestion].hint.image = null;
            }
            else {
                this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].optionsGroups[this.imgUploadGroupQuestion].image = null;
            }
            this.imageUrl = '';
        },
        showGalleryImages() {
            this.showImage = true;
        },
        modelClose(modelState) {
            this.showImage = modelState;
        },
        saveCategoryImage(categoryImage) {
            let imageObject = [{
                name: 'gallery-image',
                url: categoryImage,
            }];
            if (this.uploadType == 'pattern') {
                this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].image = imageObject;
            } else if (this.uploadType == 'desc') {
                this.questions[this.imgUploadQuestion].descriptions[this.imgUploadoptionIndex].image = imageObject;
            } else if (this.uploadType == 'hint') {
                this.questions[this.imgUploadQuestion].hint.image = categoryImage;
            } else {
                this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].optionsGroups[this.imgUploadGroupQuestion].image = categoryImage;
            }
            this.imageUrl = categoryImage;
            this.keyForLottie = this.keyForLottie + 1;

        },
        showFullScreenModal(url, questionIndex, index, type, groupIndex) {

            this.imageUrl = url;
            this.imgUploadQuestion = questionIndex;
            this.imgUploadoptionIndex = index;
            this.uploadType = type;
            this.imgUploadGroupQuestion = groupIndex;
            if (url) {
                this.showFullScreen = true;
            }
        },
        triggerFileInput(questionIndex, index, type, groupIndex) {
            this.imgUploadQuestion = questionIndex;
            this.imgUploadoptionIndex = index;
            this.uploadType = type;
            this.imgUploadGroupQuestion = groupIndex;
            if (type == 'pattern') {
                this.$refs['ref_Input' + index][0].click();
            } else if (type == 'desc') {
                this.$refs['ref_Input_desc' + index][0].click();
            } else if (type == 'hint') {
                this.$refs['ref_Input_hint' + index][0].click();
            } else {
                this.$refs['ref_Input_opt' + groupIndex][0].click();
            }
        },
        async uploadFile(file, url, key, ext) {
            // console.log('ext', ext)

            try {
                const response = await axios.put(url, file, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': file.type,
                    },
                });

                if (response.status !== 200) {
                    console.error('Error uploading file:', response);
                }
                let s3Url = 'https://zape02.s3.ap-southeast-1.amazonaws.com/' + key;
                let imageObject = [{
                    name: file.name,
                    url: s3Url,
                }];
                if (this.uploadType == 'pattern') {
                    this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].image = imageObject;
                } else if (this.uploadType == 'desc') {
                    this.questions[this.imgUploadQuestion].descriptions[this.imgUploadoptionIndex].image = imageObject;
                }
                else if (this.uploadType == 'hint') {
                    this.questions[this.imgUploadQuestion].hint.image = s3Url;
                }
                else {
                    this.questions[this.imgUploadQuestion].patterns[this.imgUploadoptionIndex].optionsGroups[this.imgUploadGroupQuestion].image = s3Url;
                }
                this.imageUrl = s3Url;
                this.createGalleryImage(s3Url, file.name, ext)
                this.keyForLottie += 1;
            } catch (error) {
                console.error('Error uploading file:', error);
            }
        },
        async createGalleryImage(s3Url, fileName, ext) {
            try {
                let galleryObj = {
                    name: fileName,
                    url: s3Url,
                    imageFormat: ext

                }
                await axios.post(process.env.VUE_APP_API_URL + '/gallery/image/create', galleryObj, {
                    headers: {
                        Authorization: this.bearerToken,
                    },
                });
            } catch (error) {
                console.error('Error saving image to gallery', error);
            }
        },
        async ImageRendererItems(event) {
            const file = event.target.files[0];
            if (file) {
                // const fileType = file.type;
                // const fileExtension = this.getFileExtension(fileType);

                const ext = file.name.split('.').pop().toLowerCase();
                let fileExtension;
                if (ext === 'lottie') {
                    fileExtension = 'lottie'
                } else {
                    fileExtension = this.getFileExtension(file.type);
                }


                try {
                    const response = await axios.post(process.env.VUE_APP_API_URL + '/s3/generate-presigned-url', {
                        type: file.type,
                        ext: fileExtension
                    }, {
                        headers: {
                            Authorization: this.bearerToken,
                        },
                    });
                    const { url, key } = response.data;
                    const extention = fileExtension == 'json' ? 'lottie' : fileExtension
                    await this.uploadFile(file, url, key, extention);
                } catch (error) {
                    console.error('Error getting pre-signed URL:', error);
                }
            }
            event.target.value = null;
        },
        getFileExtension(mimeType) {
            const mimeToExtension = {
                'image/jpeg': 'jpg',
                'image/png': 'png',
                'image/gif': 'gif',
                'application/json': 'json',
                'image/svg+xml': 'svg',
                '.json': 'json',
                '.lottie': 'lottie',
                'lottie': 'lottie',
            };
            return mimeToExtension[mimeType] || 'png';
        },

        ///////////////////////
        resetGptModel() {
            this.errorMsg = "";
        },

        async createQuestionJson(text) {
            const gptQuestion = Helpers.seriesQuestionsTextToJson(text);

            if (gptQuestion.length > 0) {
                const { questionNo, incrementDescAndOpt } = this.calculateQuestionNoAndFlag();
                this.assignQuestionNumbers(gptQuestion, questionNo);
                if (incrementDescAndOpt) {
                    this.adjustDescriptionsAndOptions(gptQuestion);
                } else {
                    this.setInitialDescriptionAndOptionCounts(gptQuestion);
                    this.questions = gptQuestion;
                }
                this.$bvModal.hide("gpt-series-questions-modal");
            } else {
                this.errorMsg = "Invalid text format";
            }
            return;

            const payload = { text: text };
            try {
                const resp = await axios.post(process.env.VUE_APP_API_URL + `/question/text/json/series`, payload, {
                    headers: { Authorization: this.bearerToken },
                });
                let gptQuestion = resp.data;
                if (gptQuestion.length > 0) {
                    const { questionNo, incrementDescAndOpt } = this.calculateQuestionNoAndFlag();
                    this.assignQuestionNumbers(gptQuestion, questionNo);
                    if (incrementDescAndOpt) {
                        this.adjustDescriptionsAndOptions(gptQuestion);
                    } else {
                        this.setInitialDescriptionAndOptionCounts(gptQuestion);
                        this.questions = gptQuestion;
                    }
                    this.$bvModal.hide("gpt-questions-modal");
                } else {
                    this.errorMsg = "Invalid text format";
                }
            } catch (error) {
                this.errorMsg = "Invalid text format";
            }
        },

        calculateQuestionNoAndFlag() {
            let questionNo = 1;
            let incrementDescAndOpt = false;
            if (this.questions.length > 0) {
                questionNo = this.questions[this.questions.length - 1].questionNo + 1;
                incrementDescAndOpt = true;
            }
            return { questionNo, incrementDescAndOpt };
        },

        assignQuestionNumbers(gptQuestion, questionNo) {
            gptQuestion.forEach((question, index) => {
                question.questionNo = questionNo + index;
            });
        },

        adjustDescriptionsAndOptions(gptQuestion) {
            this.adjustDescriptions(gptQuestion);
            this.adjustOptions(gptQuestion);
            this.updateDescriptionAndOptionCounts();
            this.questions.push(...gptQuestion);
        },

        adjustDescriptions(gptQuestion) {
            const descriptionCount = gptQuestion[0].descriptions.length;
            if (this.descriptionCount !== descriptionCount) {
                if (this.descriptionCount > descriptionCount) {
                    this.addExtraDescriptions(gptQuestion, descriptionCount);
                } else {
                    this.addExtraDescriptionsToExistingQuestions(descriptionCount);
                }
            }
        },

        addExtraDescriptions(gptQuestion, descriptionCount) {
            for (let index = descriptionCount; index < this.descriptionCount; index++) {
                gptQuestion.forEach((question) => {
                    question.descriptions.push({
                        title: "",
                        tts: "",
                        type: "text",
                        image: null,
                    });
                });
            }
        },

        addExtraDescriptionsToExistingQuestions(descriptionCount) {
            for (let index = this.descriptionCount; index < descriptionCount; index++) {
                this.questions.forEach((question) => {
                    question.descriptions.push({
                        title: "",
                        tts: "",
                        type: "text",
                        image: null,
                    });
                });
            }
        },

        adjustOptions(gptQuestion) {
            const optionCount = gptQuestion[0].patterns.length;
            if (this.optionCount !== optionCount) {
                if (this.optionCount > optionCount) {
                    this.addExtraOptions(gptQuestion, optionCount);
                } else {
                    this.addExtraOptionsToExistingQuestions(optionCount);
                }
            }
        },

        addExtraOptions(gptQuestion, optionCount) {
            for (let index = optionCount; index < this.optionCount; index++) {
                gptQuestion.forEach((question) => {
                    question.options.push({
                        title: "",
                        tts: "",
                        type: "text",
                        image: null,
                    });
                });
            }
        },

        addExtraOptionsToExistingQuestions(optionCount) {
            for (let index = this.optionCount; index < optionCount; index++) {
                this.questions.forEach((question) => {
                    question.options.push({
                        title: "",
                        tts: "",
                        type: "text",
                        image: null,
                    });
                });
            }
        },

        updateDescriptionAndOptionCounts() {
            this.descriptionCount = this.questions[0].descriptions.length;
            this.optionCount = this.questions[0].patterns.length;
        },

        setInitialDescriptionAndOptionCounts(gptQuestion) {
            this.descriptionCount = gptQuestion[0].descriptions.length;
            this.optionCount = gptQuestion[0].patterns.length;
        },
        ///////////////////////

        onFocus(event) {
            const target = event.target;
            target.style.background = '#FFFFFF';
            target.style.position = 'absolute';
            target.style.top = 0;
            target.style.left = 0;
            target.style.width = '225px';
            target.style.zIndex = '10';
            target.style.minHeight = '38px';
            target.style.height = 'auto';
            target.style.padding = '20px';
            target.style.fontSize = '14px';
            // target.style.whiteSpace = 'normal';
            target.style.whiteSpace = 'pre-wrap';
            target.style.overflow = 'auto';
            target.style.border = '1px solid #ebe9f1';
            target.style.removeProperty('height');
            target.style.setProperty('max-height', 'none', 'important');
        },

        onBlur(event, index, name, childIndex, childName, patternIndex) {
            const target = event.target;
            target.style.background = '';
            target.style.position = '';
            target.style.top = '';
            target.style.left = '';
            target.style.width = '';
            target.style.minHeight = '';
            target.style.zIndex = '';
            target.style.height = '';
            target.style.padding = '';
            target.style.fontSize = '';
            target.style.whiteSpace = 'pre-wrap';
            // target.style.whiteSpace = 'nowrap';
            target.style.overflow = 'hidden';
            target.style.border = '';
            target.style.maxHeight = '38px';
            this.updateQuestionValues(event, index, name, childIndex, childName, patternIndex);
        },
        // stripHtml(html) {
        //     // const htmlWithSpaces = html.replace(/&nbsp;/g, ' ');
        //     const htmlWithSpaces = html.replace(/&nbsp;|\u00a0/g, ' ');
        //     const textWithoutTags = htmlWithSpaces.replace(/<[^>]*>?/gm, '');
        //     // const decodedText = this.decodeHTMLEntities(textWithoutTags);
        //     return textWithoutTags;
        // },

            stripHtml(html) {
        // Create a temporary div element
        const temp = document.createElement("div");
        // Set the HTML content
        temp.innerHTML = html;
        // Get the text content, which will properly decode HTML entities
        const text = temp.textContent || temp.innerText || "";
        // Replace any remaining nbsp characters with regular spaces
        return text.replace(/&nbsp;|\u00a0/g, ' ').trim();
    },

        // decodeHTMLEntities(text) {
        //     const textArea = document.createElement('textarea');
        //     textArea.innerHTML = text;
        //     return textArea.value;
        // },
        updateQuestionValues(event, index, name, childIndex, childName, patternIndex) {
            // const innerHtml = event.target.innerHTML;
         

            const innerHtml = event.target.textContent.trim();
            const text = this.stripHtml(innerHtml);
               console.log('text', JSON.stringify(text, null, 10))
            if (name === 'title') {
                this.questions[index].title = text;
            }

            if (name === 'titleTts') {
                this.questions[index].titleTts = text;
            }
            if (name === 'hint') {
                this.questions[index].hint.text = text;
            }

            if (name === 'desc') {
                if (childName === 'title') {
                    this.questions[index].descriptions[childIndex].title = text;
                }

                if (childName === 'tts') {
                    this.questions[index].descriptions[childIndex].tts = text;
                }
            }

            if (name === 'expression') {
                if (childName === 'expression') {
                    this.questions[index].patterns[childIndex].expression = text;
                }

                if (childName === 'answer') {
                    this.questions[index].patterns[childIndex].answer = text;
                }

                if (childName === 'title' && this.questions[index].patterns[childIndex].optionsGroups[patternIndex]) {
                    this.questions[index].patterns[childIndex].optionsGroups[patternIndex].title = text;
                }

                if (childName === 'tts' && this.questions[index].patterns[childIndex].optionsGroups[patternIndex]) {
                    this.questions[index].patterns[childIndex].optionsGroups[patternIndex].tts = text;
                }
            }
        },
        onDragStart(event) {
            this.dragIndex = event.oldIndex;
        },
        onDragEnd(event) {
            this.dropIndex = event.newIndex;
            this.drag = false;
            this.questions.forEach((question, index) => {
                question.questionNo = index + 1;
            });
        },
        updateStickTitle() {
            this.isStickyTitle = !this.isStickyTitle;
        },
        updateStickFunction() {
            this.isStickyNumber = !this.isStickyNumber;
        },
        // duplicateQuestion(question) {
        //     let duplicateObject = question;
        //     let newQuestion = JSON.parse(JSON.stringify(duplicateObject));
        //     delete newQuestion._id;
        //     newQuestion.questionNo =
        //         this.questions[this.questions.length - 1].questionNo + 1;
        //     this.questions.push(newQuestion);
        // },
        duplicateQuestion(question) {
            let duplicateObject = question;
            let newQuestion = JSON.parse(JSON.stringify(duplicateObject));
            delete newQuestion._id;

            // Convert questionNo to integer before incrementing
            newQuestion.questionNo =
                parseInt(this.questions[this.questions.length - 1].questionNo, 10) + 1;

            this.questions.push(newQuestion);
        },

        hideFields() {
            this.isFieldDropdown = false;
        },
        hideShowField() {
            this.isFieldDropdown = !this.isFieldDropdown;
        },
        async handleBeforeUnload(event) {
            let updatedQuestion = await this.updateQuestionsChanges();
            let newQuestion = await this.newQuestion();
            if (updatedQuestion.length !== 0 || newQuestion.length !== 0) {
                const message =
                    "You have unsaved changes. Are you sure you want to leave?";
                event.returnValue = message;
                return message;
            }
        },
        updateQuestionsChanges() {
            const updatedArray = this.questions;
            let updateQuestion = [];
            for (let i = 0; i < this.originalQuestions.length; i++) {
                const originalObj = this.originalQuestions[i];
                const updatedObj = updatedArray.find(
                    (obj) => obj._id === originalObj._id
                );
                if (
                    updatedObj &&
                    JSON.stringify(originalObj) !== JSON.stringify(updatedObj)
                ) {
                    updateQuestion.push(updatedObj);
                }
            }
            return updateQuestion;
        },
        newQuestion() {
            const newQuestion = this.questions.filter(
                (obj) => obj._id === undefined
            );
            return newQuestion;
        },
        async saveQuestions() {
            let updatedQuestion = await this.updateQuestionsChanges();
            let newQuestion = await this.newQuestion();

            if (updatedQuestion.length === 0 && newQuestion.length === 0) {
                return "No changes or new questions found.";
            } else {
                const payload = {
                    updateQuestions: updatedQuestion,
                    newQuestions: newQuestion,
                    questions: this.questions,
                    levelId: this.$route.params.levelId,
                };
                try {
                    const res = await axios.put(
                        process.env.VUE_APP_API_URL + `/questions`,
                        payload,
                        {
                            headers: {
                                Authorization: this.bearerToken,
                            },
                        }
                    );
                    this.$bvModal.hide("save-series-question-modal");
                    await this.getQuestions();
                    this.alertMessageToast = res.data.message;
                    this.showToast("success");
                } catch (error) { }
            }
        },
        confirmDelete() {
            const selectedQuestions = this.questions.filter(
                (question) => question.checkbox
            ).length;
            if (!selectedQuestions) {
                return;
            }

            let msg =
                selectedQuestions > 1
                    ? "Do You want to delete questions!"
                    : "Do You want to delete question!";
            Swal.fire({
                title: "Are you sure?",
                text: msg,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deleteQuestions();
                }
            });
        },
        toggleSelectedQuestion() {
            this.tableCheckbox = false;
        },
        checkUncheckQuestion() {
            this.questions.forEach((question) => {
                question.checkbox = this.tableCheckbox;
            });
        },
        addPattern() {
            this.questions.forEach((question) => {
                question.patterns.push({
                    expression: "",
                    answer: "",
                    image: [],
                    optionsGroups: [
                        {
                            title: "",
                            tts: "",
                            image: "",
                        }
                    ]
                });
            });
            this.patternCount = this.patternCount + 1;
        },
        removePattern(index) {
            const indexToRemove = index;

            this.questions.forEach((question) => {
                if (
                    question.patterns &&
                    question.patterns.length > indexToRemove
                ) {
                    question.patterns.splice(indexToRemove, 1);
                }
            });
            this.patternCount = this.patternCount - 1;
        },
        addGroup(index) {
            this.questions.forEach((question) => {
                question.patterns[index].optionsGroups.push({
                    title: "",
                    tts: "",
                    type: "text",
                    image: null,
                });
            });
        },
        removeOptionGroup(index, groupIndex) {
            const indexToRemove = groupIndex;

            this.questions.forEach((question) => {
                if (
                    question.patterns &&
                    question.patterns[index] &&
                    question.patterns[index].optionsGroups &&
                    question.patterns[index].optionsGroups[indexToRemove]
                ) {
                    question.patterns[index].optionsGroups.splice(indexToRemove, 1);
                }
            });
        },
        async addQuestions(question) {
            try {
                const payload = {
                    levelId: this.$route.params.levelId,
                    questions: [question],
                };
                await axios.post(
                    process.env.VUE_APP_API_URL + "/questions",
                    payload,
                    {
                        headers: {
                            Authorization:
                                "Bearer " + localStorage.getItem("_t"),
                        },
                    }
                );
                await this.getQuestions();
            } catch (error) { }
        },
        async addNewQuestion() {

            let newObject = await this.createObject();
            let newQuestion = JSON.parse(JSON.stringify(newObject));
            // console.log('newQuestion', JSON.stringify(newQuestion, null, 10))
            this.questions.push(newQuestion);
        },
        createObject() {
            let questionNo = this.questions.length + 1;
            if (this.questions.length > 0) {
                // questionNo =
                //     this.questions[this.questions.length - 1].questionNo + 1;
                questionNo = parseInt(this.questions[this.questions.length - 1].questionNo, 10) + 1; // Convert to integer
            }

            const obj = {
                checkbox: false,
                plugin: "MissingElements",
                questionNo: questionNo,
                questionType: "Series",
                title: "",
                titleTts: "",
                hint: {
                    text: "",
                    image: ""
                },
                patterns: [],
                descriptions: [],
            };
            for (let i = 0; i < this.descriptionCount; i++) {
                obj.descriptions.push({
                    title: "",
                    tts: "",
                    type: "text",
                    image: [],
                });
            }

            for (let i = 0; i < this.patternCount; i++) {
                let groupsObj = {
                    "title": "", "tts": "", "image": ""
                }
                let groupsArr = [];
                if (this.questions.length > 0 && this.questions[0].patterns[i].optionsGroups && this.questions[0].patterns[i].optionsGroups.length > 0) {
                    this.questions[0].patterns[i].optionsGroups.forEach(e => {
                        groupsArr.push(groupsObj);
                    });
                } else {
                    groupsArr.push(groupsObj);
                }
                obj.patterns.push({
                    expression: "",
                    answer: "",
                    image: [],
                    optionsGroups: groupsArr
                });
            }
            return obj;
        },
        async getQuestions() {
            this.show = true;
            const payload = {};
            payload.search = this.searchQuery;
            try {
                const res = await axios.get(
                    process.env.VUE_APP_API_URL +
                    `/questions/${this.$route.params.levelId}/Series`,
                    {
                        headers: {
                            Authorization: this.bearerToken,
                        },
                    }
                );
                if (res.data && res.data.questions.length > 0) {
                    this.descriptionCount =
                        res.data.questions[0].descriptions.length;
                    this.patternCount =
                        res.data.questions[0].patterns.length;
                }

                let data = this.insertHint(res.data.questions)
                if (data) {
                    this.questions = data;
                } else {
                    this.questions = res.data.questions
                }
                this.originalQuestions = JSON.parse(
                    JSON.stringify(res.data.questions)
                );

                this.show = false;
            } catch (error) {
                this.show = false;
            }
        },

        insertHint(data) {
            data.forEach((question) => {
                if (!question.hint) {
                    this.$set(question, 'hint', {
                        text: "",
                        image: ""
                    });
                }
                return question;
            });
        },

        showToast(variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Notification",
                    icon: "BellIcon",
                    text: this.alertMessageToast,
                    variant,
                },
            });
        },
        async fetch() {
            await this.getQuestions();
        },
        async deleteQuestions() {

            const selectedIds = this.questions
                .filter((question) => question.checkbox && question._id)
                .map((question) => question._id);

            const payload = {
                ids: selectedIds,
            };
            try {
                await axios.post(
                    process.env.VUE_APP_API_URL + `/questions/delete`,
                    payload,
                    {
                        headers: {
                            Authorization: this.bearerToken,
                        },
                    }
                );
                this.questions = this.questions.filter(
                    (question) => !question.checkbox
                );

                this.questions.forEach((question, index) => {
                    question.questionNo = index + 1;
                });

                this.selectedQuestions = [];
                this.tableCheckbox = false;
                this.alertMessageToast = 'Questions deleted successfully!';
                this.showToast("success");
            } catch (error) {
                this.alertMessageToast = 'Error deleting questions!';
                this.showToast("danger");
            }
        },
    },
};
</script>
